<script>
export default {
  name: 'commons',
  methods: {
    getParams: function (objects) {
      const changeParams = objects
      for (let [key, value] of Object.entries(changeParams)) {
        objects[key] = (value === '' || value === null) ? null : value
      }
      return changeParams
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/commons/axiosCommons.vue